const pcninsights = [
  {
    size: "",
    style: "",
    class: "",
    children: [
      {
        type: "topbar",
        size: "12",
        style: "",
        class: "px-4",
        title: "PCN Insights",
      },
      {
        type: "tabs",
        size: "12",
        style: "",
        class: "px-4 pt-4",
        children: [
          {
            title: "Settings",
            service: "category",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: false,
              activeToggle: false,
              deleteButton: false,
              updateSuccessTitle: "Category Updated!",
              updateSuccessMessage: "Category Updated Successfully!",
              updateErrorTitle: "Category Updation Failed!",
              updateErrorMessage: "Please try again!",
            },
            children: [
              {
                type: "descriptionTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  type: "list",
                  size: "4",
                  style: "",
                  class: "p-2",
                  empty: true,
                  children: [],
                },
                form: {
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  form: {
                    description: {
                      type: "ckeditor",
                      label: "Description",
                      placeholder: "Enter Description",
                      required: true,
                      info: false,
                      character_count: 2000,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr1: {
                      type: "hr",
                      size: "12",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
          {
            title: "Insights",
            service: "pages",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: true,
              activeToggle: true,
              deleteButton: true,
              addNewSuccessTitle: "Insight Added!",
              addNewSuccessMessage: "Insight Added Successfully!",
              addNewErrorTitle: "Insight Creation Failed!",
              addNewErrorMessage: "Please try again!",
              deleteSuccessTitle: "Insight Deleted!",
              deleteSuccessMessage: "Insight Deleted Successfully!",
              deleteErrorTitle: "Insight Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Insight Activated!",
              activeSuccessMessage: "Insight Activated Successfully!",
              activeErrorTitle: "Insight Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Insight Updated!",
              updateSuccessMessage: "Insight Updated Successfully!",
              updateErrorTitle: "Insight Update Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New PCN Insight",
                submit_url: "/api/categories/$currentCategoryId/pages",
                variant: "add",
                form: {
                  title: {
                    type: "text",
                    label: "Title",
                    placeholder: "Enter Title",
                    required: true,
                    info: true,
                    character_count: 100,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                },
                additionalProps: {
                  total_appointments_booked: "",
                  total_dna: "",
                  total_telephone_appointments: "",
                  total_in_person_appointments: "",
                  period: "current_month",
                },
              },
            },
            children: [
              {
                type: "pcnServicesTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "Select PCN Insight",
                  type: "list",
                  info: true,
                  size: "4",
                  style:
                    "border-right: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "p-0 pt-3 pr-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  children: [],
                  isGlobal: false,
                  featuredIcon_position: "left",
                },
                form: {
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  submit_url: "/api/pages/$currentPageId",
                  form: {
                    title: {
                      type: "text",
                      label: "Insight Title",
                      placeholder: "Enter Insight Title",
                      required: true,
                      info: true,
                      character_count: 100,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr1: {
                      type: "hr",
                      size: "12",
                    },
                    appointment_booking_data: {
                      type: "heading",
                      label: "Appointment Booking Data",
                      size: "12",
                    },
                    total_appointments_booked: {
                      type: "text",
                      label: "Total Appointments Booked This Month",
                      placeholder: "Enter total appointments booked",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    total_dna: {
                      type: "text",
                      label: "Total DNA",
                      placeholder: "Enter total DNA",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    total_telephone_appointments: {
                      type: "text",
                      label: "Total Telephone Appointments",
                      placeholder: "Enter total telephone appointments",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    total_in_person_appointments: {
                      type: "text",
                      label: "Total In-Person Appointments",
                      placeholder: "Enter total in-person appointments",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    hr2: {
                      type: "hr",
                      size: "12",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

export { pcninsights };
